import { LitElement, html } from './-global.min.js'

class HHProductCardVariants extends LitElement {
  get anchor() {
    return this.querySelector('.js-anchor')
  }

  get variantButtons() {
    return [...this.querySelectorAll('.js-swatch')]
  }

  connectedCallback() {
    super.connectedCallback()
    this.variantButtons.forEach((button) => {
      button.addEventListener('click', this.onClickHandler.bind(this))
    })

    this.productFormInput = this.closest('hh-product-form')?.querySelector(
      '.js-product-form-input'
    )

    this.submitButton = this.closest('hh-product-form')?.querySelector(
      '.js-product-form-button'
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.variantButtons.forEach((button) => {
      button.removeEventListener('click', this.onClickHandler)
    })
  }

  onClickHandler(event) {
    event.preventDefault()
    this.anchor.href = event.target.dataset.variantUrl
    this.hideAllVariantImages()
    this.showVariantImage(event)
    this.variantButtons.forEach((el) => {
      el.classList.remove('active')
    })

    event.target.classList.add('active')

    // Note: if you do not have a quick buy in the product card, you can delete these two functions
    this.handleProductFormId(event)
    this.handleProductFormButton(event)
  }

  hideAllVariantImages() {
    this.querySelectorAll('[data-variant-color]').forEach((element) => {
      element.classList.remove('active')
    })
  }

  showVariantImage(event) {
    const vname = event.target.dataset.variantName
    const selector = '[data-variant-color="' + vname + '"]'
    const swatch = this.querySelector(selector)
    swatch?.classList.add('active')
  }

  handleProductFormId(event) {
    if (!this.productFormInput) return
    const variantId = event.target.dataset.variantId

    if (variantId) {
      this.productFormInput.value = variantId
    }
  }

  handleProductFormButton(event) {
    if (!this.submitButton) return
    const isAvailable = event.target.dataset.variantAvailable === 'true'

    this.submitButton.disabled = !isAvailable
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card-variants', HHProductCardVariants)
